module.exports = __webpack_public_path__ + "img/恐龙蛋翼龙公仔.eb7ba2b3.jpg";